import React from 'react';
const striptags = require('striptags');
import Highlight from 'sis_ui/modules/highlight/Highlight';
import TruncateMarkup  from 'react-truncate-markup';
import withContainerDimensions from 'components/ContainerDimensions/index';
import {checkIfEvaluationIsClickable, learnerNotClickableList} from '../components/List';
import {useTranslation} from "react-i18next";
import userService from 'services/userService';

const CardTitle = ({ data, key }) => {
  const WrappedCardTitle = withContainerDimensions({
    key,
    widthAdjustment: 25,
    text: data,
  })(TruncateMarkup);

  return (
    <h3 className="evaluation-card__title">
      <WrappedCardTitle lines={1} />
    </h3>
  );
};

const CardActivity = ({ data, key }) => {
  const WrappedCardActivity = withContainerDimensions({
    key,
    widthAdjustment: 25,
    text: data,
  })(TruncateMarkup);

  return (
    <div className="evaluation-card__activity color-grey">
      <strong>
        <WrappedCardActivity lines={2} />
      </strong>
    </div>
  );
};

const EPAName = ({data, key}) => {
    const WrappedCardEPAName = withContainerDimensions({
        key,
        widthAdjustment: 25,
        text: data,
      })(TruncateMarkup);

    return (
    <div className="evaluation-card__epa color-grey">
         <WrappedCardEPAName lines={1} />
    </div>)
}

const EvaluationItem = ({data}) => {
    const currentRole = userService.getUserRole();    
    const isClickable = checkIfEvaluationIsClickable({evaluation  : data, currentRole, learnerNotClickableList, checkRequiredEvaluation: true});    
    const {t} = useTranslation()
    let statusCodeText = data.STATUS_NAME;
    let statusCodeClass;

    switch(data.STATUS_CODE){
        case "DRAFT" :
            statusCodeClass = "draft";
        break;
        case "COMPLETED" :
            statusCodeClass = "complete";
        break;
        case "PENDING" :
            statusCodeClass = "pending";
        break;
        case "IN_PROGRESS" :
            statusCodeClass = "progress";
        break;
        case "SCHEDULED":
            statusCodeClass = "scheduled";
         break;
        case "NOT_DISTRIBUTED":
            statusCodeClass = "not-distributed";
        break;
        case "UNDER_REVISION":
            statusCodeClass = "under-revision";
        break;
        case "DECLINED":
            statusCodeClass = "declined";
        break;
        case "EXPIRED":
            statusCodeClass = "expired";
        break;
        default:
            statusCodeClass = "not-defined";
    }

    return (
        <div className={`evaluation-card shadow-depth-1 ${isClickable ? "" : "not-clickable"}`}>
            <Highlight>
                <div className={"evaluation-card__status " + statusCodeClass}>
                    <span className="status">{statusCodeText}</span>
                </div>
                <div className="evaluation-card__content">
                    <CardTitle data={data.NAME} key={data.EVALUATION_ID} />
                    <CardActivity data={data.ACTIVITY} key={data.EVALUATION_ID} />
                    <EPAName data={data.EPA_NAME} key={data.EVALUATION_ID} />
                    <div className="evaluation-card__evaluator_evaluatee">{striptags(data.EVALUATION_USER)}</div>
                    <div className="row evaluation-card__date_days_to_expire">
                        <span className="col color-grey">
                            {data.DAYS_TO_EXPIRE ?
                                <span>{t("lbl.DAYS_TO_EXPIRE","Days to expire")}: <span className="evaluation-card__days_to_expire color-red">{data.DAYS_TO_EXPIRE}</span></span>
                            :
                                null
                            }
                            <span className="evaluation-card__date pull-right">{data.START_DT} / {data.END_DT}</span>
                        </span>
                    </div>
                </div>
            </Highlight>
        </div>
    );
}

export default EvaluationItem;